import React, { useState, useEffect, useCallback } from "react";
import "../style/events.css";

function Events() {
  const [slideIndex, setSlideIndex] = useState(1);

  // Next/previous controls
  const plusSlides = (n) => {
    showSlides(slideIndex + n);
  };

  const showSlides = useCallback((n) => {
    let i;
    const slides = document.getElementsByClassName("mySlides");

    if (n > slides.length) {
      n = 1;
    } else if (n < 1) {
      n = slides.length;
    }

    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }

    slides[n - 1].style.display = "block";
    setSlideIndex(n);
  }, []);

  useEffect(() => {
    showSlides(slideIndex);
  }, [slideIndex, showSlides]);

  const ScrollInterval = React.useRef(null);

  const ScrollDiv = () => {
    const ecran = document.getElementById("ecran");
    if (ecran && ecran.scrollTop < ecran.scrollHeight - ecran.offsetHeight) {
      ecran.scrollTop = ecran.scrollTop + 1;
    } else {
      ecran.scrollTop = 0;
    }
  };

  const pauseDiv = () => {
    if (ScrollInterval.current) {
      clearInterval(ScrollInterval.current);
    }
  };

  const resumeDiv = () => {
    if (ScrollInterval.current) {
      clearInterval(ScrollInterval.current);
    }
    ScrollInterval.current = setInterval(ScrollDiv, 400);
  };

  useEffect(() => {
    resumeDiv();
    return () => {
      if (ScrollInterval.current) {
        clearInterval(ScrollInterval.current);
      }
    };
  }, []);

  return (
    <>
      <div className="layer-4">
        <div className="Events">
          <div className="Line3"></div>
          <div className="Event-header">Events</div>

          <div className="Frame30">
            <div className="mySlides fade1">
              <img
                src="/images/Sport-day-2.png"
                alt="sport-2"
                className="slide-carousel"
              />
              <div className="text">Yoga Day</div>
            </div>
            <div className="mySlides fade1">
              <img
                src="../images/Sport-day-1.png"
                alt="sport-1"
                className="slide-carousel"
              />
              <div className="text">Sports Day</div>
            </div>

            <div className="mySlides fade1">
              <img
                src="/images/Sport-day-3.png"
                alt="sport-3"
                className="slide-carousel"
              />
              <div className="text">Sravan Utsav</div>
            </div>

            <div className="mySlides fade1">
              <img
                src="/images/sport-day-4.png"
                alt="sport-4"
                className="slide-carousel"
              />
              <div className="text">Guru har krishnan sahib ji day</div>
            </div>

            <div className="mySlides fade1">
              <img
                src="/images/sport-day-5.png"
                alt="sport-5"
                className="slide-carousel"
              />
              <div className="text">Farewell</div>
            </div>

            <div className="mySlides fade1">
              <img
                src="/images/sport-day-6.png"
                alt="sport-6"
                className="slide-carousel"
              />
              <div className="text">Independence Day</div>
            </div>

            <div className="mySlides fade1">
              <img
                src="/images/sport-day-7.png"
                alt="sport-7"
                className="slide-carousel"
              />
              <div className="text">Guru Purnima</div>
            </div>

            <button className="prev" onClick={() => plusSlides(-1)}>
              &#10094;
            </button>
            <button className="next" onClick={() => plusSlides(1)}>
              &#10095;
            </button>
          </div>
        </div>
        <div className="announcement-career">
          <div className="announcement-container">
            <div className="announcement-header">Announcement</div>
            <div
              className="announcement-content"
              id="ecran"
              onMouseOver={pauseDiv}
              onMouseOut={resumeDiv}
            >
              <div className="announcement-item">
                <div className="arrow-image">
                  <img src="../images/Default.png" alt="arrow" className="arw" />
                </div>
                <div className="text-ann">
                  <div className="ann-text-wrapper">
                    Admission Open For The Year 2025-26
                    <span className="New">New</span>
                  </div>
                </div>
              </div>
              <div className="Line2"></div>

              <div className="announcement-item">
                <div className="arrow-image">
                  <img src="../images/Default.png" alt="arrow" className="arw" />
                </div>
                <div className="text-ann">
                  <div className="ann-text-wrapper">
                    Training For Stage Acting Zumba Started From July 2025
                    <span className="New">New</span>
                  </div>
                </div>
              </div>
              <div className="Line2"></div>

              <div className="announcement-item">
                <div className="arrow-image">
                  <img src="../images/Default.png" alt="arrow" className="arw" />
                </div>
                <div className="text-ann">
                  <div className="ann-text-wrapper">
                    Sports Academy Where Coaching Is Given For Specific Games
                    <span className="New">New</span>
                  </div>
                  <div className="sports-list">
                    <span>Football</span>
                    <span>Physical Fitness</span>
                    <span>Gymnastics</span>
                    <span>Yoga</span>
                    <span>Karate</span>
                    <span>Skating</span>
                    <span>Basketball</span>
                  </div>
                </div>
              </div>
              <div className="Line2"></div>

              <div className="announcement-item">
                <div className="arrow-image">
                  <img src="../images/Default.png" alt="arrow" className="arw" />
                </div>
                <div className="text-ann">
                  <div className="ann-text-wrapper">
                    Special Training For Arts, Artistic Sensibilities. Activity for Primary Shed & Secondary.
                    <span className="New">New</span>
                  </div>
                </div>
              </div>
              <div className="Line2"></div>

              <div className="announcement-item">
                <div className="arrow-image">
                  <img src="../images/Default.png" alt="arrow" className="arw" />
                </div>
                <div className="text-ann">
                  <div className="ann-text-wrapper">
                    Training for Elementary & Intermediate State Drawing Examinations
                    <span className="New">New</span>
                  </div>
                </div>
              </div>
              <div className="Line2"></div>

              <div className="announcement-item">
                <div className="arrow-image">
                  <img src="../images/Default.png" alt="arrow" className="arw" />
                </div>
                <div className="text-ann">
                  <div className="ann-text-wrapper">
                    Special Training Music
                    <span className="New">New</span>
                  </div>
                  <div className="sports-list">
                    <span>Harmonium</span>
                    <span>Tabla</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="career-container">
            <div className="career-header">Career</div>
            <div className="career-content">
              <div className="career-item">
                <div className="arrow-image">
                  <img src="../images/Default-blue.png" alt="arrow" className="arw" />
                </div>
                <div className="text-ann">
                  <div className="ann-text-wrapper">
                    We are hiring Teaching, administrative & house keeping staff.
                    <span className="New">New</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Events;